"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _InputStyled = require("../Input/InputStyled");
var _MyAccountInputStyled = require("./MyAccountInputStyled");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class MyAccountInput extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const {
      id,
      placeholder,
      type,
      min,
      value,
      label,
      onChange,
      onSubmit,
      disabled,
      hideInput,
      error,
      onBlur,
      name,
      autoComplete,
      required,
      width
    } = this.props;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_MyAccountInputStyled.WrapStyled, {
      hideInput: hideInput,
      width: width,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_MyAccountInputStyled.InputElementLabelStyled, {
        htmlFor: id,
        children: [label, required && ' *']
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountInputStyled.InputElementStyled, {
        error: error,
        id: id,
        placeholder: placeholder,
        type: type,
        min: min,
        value: value,
        disabled: disabled,
        onSubmit: onSubmit,
        onChange: onChange,
        onBlur: onBlur,
        name: name,
        autoComplete: autoComplete
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputStyled.ErrorWrapper, {
        id: "".concat(id, "-desc"),
        isMyAccount: true,
        children: error
      })]
    });
  }
}
var _default = exports.default = MyAccountInput;
MyAccountInput.propTypes = {
  id: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  type: _propTypes.default.string,
  value: _propTypes.default.string,
  min: _propTypes.default.string,
  label: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onSubmit: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  hideInput: _propTypes.default.bool,
  error: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  name: _propTypes.default.string,
  autoComplete: _propTypes.default.string,
  required: _propTypes.default.bool,
  width: _propTypes.default.string
};
MyAccountInput.defaultProps = {
  id: '',
  placeholder: '',
  type: 'text',
  value: '',
  min: '',
  label: '',
  onChange: () => null,
  onSubmit: () => null,
  onBlur: () => null,
  disabled: false,
  hideInput: false,
  error: '',
  name: '',
  autoComplete: '',
  required: false,
  width: ''
};